import {useState} from 'react';
import {useInstallPrompt} from '../hooks/useInstallPrompt';
import {trackEvent} from '../utils/analytics';

export default function InstallAppButton() {
    const {canShow, isIos, promptInstall, dismiss} = useInstallPrompt();
    const [showIosHelp, setShowIosHelp] = useState(false);

    if (!canShow) return null;

    const handleClick = () => {
        trackEvent('pwa_install_click');
        if (isIos) {
            setShowIosHelp(true);
            return;
        }
        promptInstall().then(outcome => {
            if (outcome === 'accepted') trackEvent('pwa_install_accepted');
            if (outcome === 'dismissed') trackEvent('pwa_install_dismissed');
        });
    };

    const handleDismiss = () => {
        trackEvent('pwa_install_close');
        dismiss();
    };

    return (
        <>
            <div className="fixed bottom-4 left-4 z-40 md:hidden">
                <div className="flex items-center gap-1 bg-white rounded-full shadow-2xl border border-brand-dark/10 p-1">
                    <button
                        onClick={handleClick}
                        className="flex items-center gap-2 pl-3 pr-4 py-2 rounded-full bg-gradient-to-r from-brand-red via-brand-pink to-brand-orange text-white text-sm font-medium hover:opacity-95 transition"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M12 3v12"/>
                            <path d="M7 10l5 5 5-5"/>
                            <path d="M5 21h14"/>
                        </svg>
                        Установить
                    </button>
                    <button
                        onClick={handleDismiss}
                        className="w-7 h-7 rounded-full bg-brand-gray flex items-center justify-center text-brand-dark/60 hover:bg-gray-200 transition"
                        aria-label="Закрыть"
                    >
                        <svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                            <path d="M1 1L13 13M1 13L13 1" stroke="currentColor" strokeWidth="2"
                                  strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>
            </div>

            {showIosHelp && (
                <div
                    className="fixed inset-0 bg-black/60 z-50 flex items-end md:items-center justify-center p-4 backdrop-blur-sm"
                    onClick={() => setShowIosHelp(false)}
                >
                    <div
                        className="bg-white rounded-[24px] p-6 max-w-md w-full shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3 className="text-xl font-bold text-brand-dark mb-1">Установить приложение</h3>
                        <p className="text-sm text-brand-dark/60 mb-5">Откройте Safari и выполните 3 шага:</p>
                        <ol className="space-y-3 text-brand-dark/80 text-sm mb-5">
                            <li className="flex items-start gap-3">
                                <span className="flex-none w-6 h-6 rounded-full bg-brand-gray flex items-center justify-center text-xs font-bold text-brand-dark">1</span>
                                <span>Нажмите кнопку <span className="inline-flex items-center gap-1 font-medium text-brand-dark">
                                    «Поделиться»
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <path d="M12 3v13"/>
                                        <path d="M7 8l5-5 5 5"/>
                                        <path d="M5 21h14a2 2 0 0 0 2-2v-7"/>
                                    </svg>
                                </span> в нижней панели Safari.</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <span className="flex-none w-6 h-6 rounded-full bg-brand-gray flex items-center justify-center text-xs font-bold text-brand-dark">2</span>
                                <span>Прокрутите вниз и выберите «На экран Домой».</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <span className="flex-none w-6 h-6 rounded-full bg-brand-gray flex items-center justify-center text-xs font-bold text-brand-dark">3</span>
                                <span>Нажмите «Добавить» — иконка появится на главном экране.</span>
                            </li>
                        </ol>
                        <button
                            onClick={() => setShowIosHelp(false)}
                            className="w-full py-3 rounded-2xl bg-brand-gray text-brand-dark font-medium hover:bg-gray-200 transition"
                        >
                            Понятно
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}
